import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './DashboardStyles.css';
import ProtectedPage from '../../common/ProtectedPage';
import SecretCodesManagement from './components/SecretCodesManagement';
import ProductsManagement from './components/ProductsManagement';
import tokens from '../../../utils/token';
import ClientsManagement from './components/ClientsManagement';
import CommandsManagement from './components/CommandsManagement';
import Analytics from './components/Analytics';
import Overview from './components/Overview';

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    tokens.user_token.removeToken();
    navigate('/admin/login');
  };

  const handleNavigate = (section) => {
    setActiveTab(section);
    setSidebarOpen(false); // Fermer le menu mobile si ouvert
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'products':
        return <ProductsManagement />;
      case 'clients':
        return <ClientsManagement />;
      case 'orders':
        return <CommandsManagement />;
      case 'analytics':
        return <Analytics />;
      case 'secret-codes':
        return <SecretCodesManagement />;
      case 'overview':
      default:
        return <Overview onNavigate={handleNavigate} />;
    }
  };

  return (
    <ProtectedPage key={`dashboard-${activeTab}`} permissionsNeeded="user" redirectPath='/admin/login'>
      <div className="dashboard-container">
        {/* Mobile Menu Toggle */}
        <button 
          className="mobile-menu-toggle"
          onClick={() => setSidebarOpen(!sidebarOpen)}
        >
          <i className="bi bi-list"></i>
        </button>

        {/* Mobile Overlay */}
        <div 
          className={`mobile-overlay ${sidebarOpen ? 'open' : ''}`}
          onClick={() => setSidebarOpen(false)}
        ></div>

        {/* Header */}
        <header className="dashboard-header">
          <div className="header-content">
            <div className="header-left">
              <img 
                src="/patricians.png" 
                alt="Patricians Logo" 
                className="header-logo"
              />
              <h1 className="dashboard-title">Dashboard Admin</h1>
            </div>
            <button className="logout-btn" onClick={handleLogout}>
              <i className="bi bi-box-arrow-right"></i>
              Déconnexion
            </button>
          </div>
        </header>

        <div className="dashboard-body">
          {/* Sidebar Navigation */}
          <nav className={`dashboard-sidebar ${sidebarOpen ? 'open' : ''}`}>
            <div className="sidebar-content">
              <div className="nav-section">
                <h3>Navigation</h3>
                <ul className="nav-list">
                  <li 
                    className={`nav-item ${activeTab === 'overview' ? 'active' : ''}`}
                    onClick={() => {
                      setActiveTab('overview');
                      setSidebarOpen(false);
                    }}
                  >
                    <i className="bi bi-speedometer2"></i>
                    <span>Vue d'ensemble</span>
                  </li>
                  <li 
                    className={`nav-item ${activeTab === 'products' ? 'active' : ''}`}
                    onClick={() => {
                      setActiveTab('products');
                      setSidebarOpen(false);
                    }}
                  >
                    <i className="bi bi-tshirt"></i>
                    <span>Vêtements</span>
                  </li>
                  <li 
                    className={`nav-item ${activeTab === 'clients' ? 'active' : ''}`}
                    onClick={() => {
                      setActiveTab('clients');
                      setSidebarOpen(false);
                    }}
                  >
                    <i className="bi bi-people"></i>
                    <span>Clients</span>
                  </li>
                  <li 
                    className={`nav-item ${activeTab === 'orders' ? 'active' : ''}`}
                    onClick={() => {
                      setActiveTab('orders');
                      setSidebarOpen(false);
                    }}
                  >
                    <i className="bi bi-cart-check"></i>
                    <span>Commandes</span>
                  </li>
                  <li 
                    className={`nav-item ${activeTab === 'analytics' ? 'active' : ''}`}
                    onClick={() => {
                      setActiveTab('analytics');
                      setSidebarOpen(false);
                    }}
                  >
                    <i className="bi bi-graph-up"></i>
                    <span>Analytics</span>
                  </li>
                  <li 
                    className={`nav-item ${activeTab === 'secret-codes' ? 'active' : ''}`}
                    onClick={() => {
                      setActiveTab('secret-codes');
                      setSidebarOpen(false);
                    }}
                  >
                    <i className="bi bi-key"></i>
                    <span>Codes Secrets</span>
                  </li>
                </ul>
              </div>
            </div>
          </nav>

          {/* Main Content */}
          <main className="dashboard-main">
            <div className="main-content">
              {renderContent()}
            </div>
          </main>
        </div>
      </div>
    </ProtectedPage>
  );
};

export default Dashboard;
